import classNames from 'classnames';
import { Rarity } from '@/models/profile';
import * as styles from './styles.module.scss';

interface TitleProps {
    text: string;
    rarity: Rarity;
    classname?: string;
}

export default function Title({ text, rarity, classname }: TitleProps) {
    return (
        <div className={classNames(styles.Badge, styles[rarity?.toLowerCase()], classname)}>
            <p>“{text}“</p>
        </div>
    );
}
